import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError, tap } from 'rxjs/operators';

import { AuthService } from '../../services/auth.service';
import * as AuthActions from '../actions/auth.actions';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class AuthEffects {
    private authService = inject(AuthService);
    private router = inject(Router);
    private actions$ = inject(Actions); // ✅ clean and supported for class field use
    private messageService = inject(MessageService);
    login$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.LogIn),
            switchMap(({ email, password }) =>
                this.authService.logIn(email, password).pipe(
                    map(user =>
                        AuthActions.LogInSuccess({ user: user })
                    ),
                    catchError(error =>
                        of(AuthActions.LogInFailure({ error }))
                    )
                )
            )
        )
    );

    loginSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(AuthActions.LogInSuccess),
                tap(({ user }) => {
                    if (user.is_confirmed) {
                        localStorage.setItem('token', user?.token || "");
                        localStorage.setItem('user', JSON.stringify(user));
                        this.router.navigate(['/']);
                    } else {
                        this.router.navigate(['/auth/confirm-email'], {
                            queryParams: { user_id: user.id }
                        });
                    }

                })
            ),
        { dispatch: false }
    );

    loginFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(AuthActions.LogInFailure),
                tap(({ error }) => {
                    console.error('[Effect] Login failed:', error);
                })
            ),
        { dispatch: false }
    );

    signUp$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.SignUp),
            tap(action => console.log('[Effect] SignUp received', action)),
            switchMap(({ email, password, firstName, lastName }) =>
                this.authService.signUp(email, password, firstName, lastName).pipe(
                    map(user =>
                        AuthActions.SignUpSuccess({ token: user.token || "", email })
                    ),
                    catchError(error =>
                        of(AuthActions.SignUpFailure({ error }))
                    )
                )
            )
        )
    );

    signUpSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(AuthActions.SignUpSuccess),
                tap(({ token }) => {
                    localStorage.setItem('token', token);
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Email de confirmation envoyé avec succès. Confirmer votre email pour continuer',
                        life: 3000
                    });
                    this.router.navigate(['/auth/login']);
                })
            ),
        { dispatch: false }
    );

    signUpFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(AuthActions.SignUpFailure),
                tap(({ error }) => {
                    console.error('[Effect] SignUp failed:', error);
                })
            ),
        { dispatch: false }
    );

    logout$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(AuthActions.LogOut),
                tap(() => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/auth/login']);
                })
            ),
        { dispatch: false }
    );
}
